import { default as MuiTableBody, TableBodyProps } from '@mui/material/TableBody'
import * as React from 'react'

export const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => {
  return <MuiTableBody ref={ref} {...props} />
})

export default TableBody
